;(function () {
  function appendProductType() {
    var heading = document.querySelector(
      'div.spice-spa-addon-heading[name="sg-pro-heading"]',
    )
    var productType =
      window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.product.type
    if (heading && productType) {
      heading.textContent = heading.textContent + " your " + productType
      var p = document.createElement("p")
      p.textContent = `Tick any accessories you'd like to add to your order. They will automatically be added if you choose to add the ${productType.toLowerCase()} to your basket.`
      heading.insertAdjacentElement("afterend", p)
      return true
    }
    return false
  }

  function activateTab1() {
    var el = document.getElementById("tab_1")
    if (el) {
      el.classList.add("spice-addon-group-active")
      return true
    }
    return false
  }

  function init() {
    var tabDone = activateTab1()
    var headingDone = appendProductType()

    if (!tabDone || !headingDone) {
      var observer = new MutationObserver(function () {
        if (!tabDone) tabDone = activateTab1()
        if (!headingDone) headingDone = appendProductType()
        if (tabDone && headingDone) observer.disconnect()
      })
      observer.observe(document.body, { childList: true, subtree: true })
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init)
  } else {
    init()
  }
})()
